import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
// import { BrowserRouter } from 'react-router-dom';
import { Router } from '@reach/router';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
